module.exports = __webpack_public_path__ + "img/9.b8910880.jpg";